import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=5d0806f8&"
import script from "./PageLoading.vue?vue&type=script&lang=js&"
export * from "./PageLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerPie});
